import { render, staticRenderFns } from "./RegisterWhitelabel.vue?vue&type=template&id=076591d0"
import script from "./RegisterWhitelabel.vue?vue&type=script&lang=js"
export * from "./RegisterWhitelabel.vue?vue&type=script&lang=js"
import style0 from "./RegisterWhitelabel.vue?vue&type=style&index=0&id=076591d0&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports